import type { AppRouteGroup } from 'app/store/components/NavigationUtils';

import DashboardConfig from './dashboard/DashboardConfig';
import DocumentsStructureConfig from './documents-structure/DocumentsStructureConfig';
import ErrorsConfig from './errors/ErrorsConfig';
import LoginConfig from './login/LoginConfig';
import LogsConfig from './logs/LogsConfig';
import PermissionsManagementConfig from './permissions-management/PermissionsManagementConfig';
import RecycleBinConfig from './recycle-bin/RecycleBinConfig';
import SettingsConfig from './settings/SettingsConfig';
import SystemTablesConfig from './system-table/SystemTablesConfig';
import VersionUpdateConfig from './version-update/VersionUpdateConfig';
import UsersDashboardPage from './userprofile/UsersDashboardConfig';

// Experimental
import NewsConfig from './news/NewsConfig';
// import OrganizationChartConfig from './organization-chart/OrganizationChartConfig';
import TotemConfig from './totem/TotemConfig';

const pagesConfigs: AppRouteGroup[] = [
	LoginConfig,
	DashboardConfig,
	DocumentsStructureConfig,
	ErrorsConfig,
	LogsConfig,
	NewsConfig,
	// OrganizationChartConfig,
	PermissionsManagementConfig,
	RecycleBinConfig,
	SystemTablesConfig,
	SettingsConfig,
	TotemConfig,
	VersionUpdateConfig,
	UsersDashboardPage
];

export default pagesConfigs;
